export const windDirectionIconSrc = require('../../../../../assets/images/icons/weather/wind_direction.svg').default

const WIND_DIRECTIONS: any = {
    N: {
        caption: "С",
        angles: [348.75, 11.25], // перекрытие через 360°
    },
    NNE: {
        caption: "ССВ",
        angles: [11.25, 33.75],
    },
    NE: {
        caption: "СВ",
        angles: [33.75, 56.25],
    },
    ENE: {
        caption: "ВСВ",
        angles: [56.25, 78.75],
    },
    E: {
        caption: "В",
        angles: [78.75, 101.25],
    },
    ESE: {
        caption: "ВЮВ",
        angles: [101.25, 123.75],
    },
    SE: {
        caption: "ЮВ",
        angles: [123.75, 146.25],
    },
    SSE: {
        caption: "ЮЮВ",
        angles: [146.25, 168.75],
    },
    S: {
        caption: "Ю",
        angles: [168.75, 191.25],
    },
    SSW: {
        caption: "ЮЮЗ",
        angles: [191.25, 213.75],
    },
    SW: {
        caption: "ЮЗ",
        angles: [213.75, 236.25],
    },
    WSW: {
        caption: "ЗЮЗ",
        angles: [236.25, 258.75],
    },
    W: {
        caption: "З",
        angles: [258.75, 281.25],
    },
    WNW: {
        caption: "ЗСЗ",
        angles: [281.25, 303.75],
    },
    NW: {
        caption: "СЗ",
        angles: [303.75, 326.25],
    },
    NNW: {
        caption: "ССЗ",
        angles: [326.25, 348.75],
    }
};

export function getWindDirectionByAngle(angle: number): string {
    angle = (angle + 360) % 360; // нормализуем угол

    for (const key in WIND_DIRECTIONS) {
        const { caption, angles } = WIND_DIRECTIONS[key];
        const [min, max] = angles;

        if (min > max) {
            // диапазон через 360°
            if (angle >= min || angle < max) return caption;
        } else {
            if (angle >= min && angle < max) return caption;
        }
    }

    return "Неизвестно";
}
